import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { getPlatformLogoStyle, PlatformLogoVariant } from "src/utils/platformLogoConfig";
import { frontEnvString, subscribeFrontRuntimeConfig } from "src/services/runtimeFrontConfig";

type PlatformLogoProps = {
  platformId: string;
  platformName: string;
  img: string;
  variant: PlatformLogoVariant;
};

// Same default as runtime-env seed REACT_APP_BETA_PLATFORM_IDS (used until front-config loads).
const DEFAULT_BETA_PLATFORM_IDS = "FFPC";

function isBetaPlatform(platformId: string): boolean {
  const raw = frontEnvString("REACT_APP_BETA_PLATFORM_IDS", DEFAULT_BETA_PLATFORM_IDS);
  return raw
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean)
    .includes(platformId);
}

const PlatformLogo = ({ platformId, platformName, img, variant }: PlatformLogoProps) => {
  const [, setFrontRuntimeBump] = useState(0);
  useEffect(() => subscribeFrontRuntimeConfig(() => setFrontRuntimeBump((n) => n + 1)), []);

  const isFfpc = platformId === "FFPC";
  const showBeta = variant === "dropdown" && isBetaPlatform(platformId);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={0} justifyContent="center">
      <img
        src={img}
        alt={platformName}
        style={{
          ...getPlatformLogoStyle(platformId, variant),
          display: "block",
          ...(isFfpc ? { objectPosition: "bottom" } : {}),
        }}
      />
      {/* Dropdown only: Beta label for platform ids listed in REACT_APP_BETA_PLATFORM_IDS */}
      {showBeta && (
        <Typography variant="body1" sx={{ fontSize: "12px", color: "#ffffff", p: 0, m: 0, mt: "-3px", lineHeight: 1, fontWeight: 900 }}>
          Beta
        </Typography>
      )}
    </Box>
  );
};

export default PlatformLogo;
